<template>
  <div class="home text-white">
    <div style="text-align: center">
      <b-navbar-nav class="set-padding-select">
        <b-nav-item>
          <select v-if="Object.keys(districts).length >1"
                  class="dropdown_branch"
                  id="ddown1"
                  v-model="district_id"
                  style="margin-right: 4%">
            <template v-for="item in districts">
              <option :value="item.value">{{ item.text }}</option>
            </template>
          </select>

          <select v-if="Object.keys(branchs).length >1"
                  class="dropdown_branch"
                  v-model="branch_id"
                  @change="onClickBranch($event)">
            <option value="null" disabled>-เลือกสาขา-</option>
            <template v-for="item in branchs">
              <option v-if="parseInt(district_id)  === parseInt(item.district_id)" :value="item.value">{{ item.text }}
              </option>
            </template>
          </select>
        </b-nav-item>
      </b-navbar-nav>
    </div>

    <div class="set-padding">
      <b-tabs align="center" style="font-size: 12px" nav-class="p-0">
        <b-tab :title="'Realtime Grid ('+realtime_data.length+')'" active>
          <table class="table table-borderless table-striped text-white">
            <tbody>
              <tr v-for="item in realtime_data">
                <td>
                  <v-row v-b-toggle="'real' + item.code">
                    <v-col>

                      <span
                        v-if="item.status == 130
                             || item.status == 140
                             || item.status == 230
                             || item.status == 240
                             || item.status == 480
                             || item.status == 500"
                        class="circle-red"
                      >
                        <font-awesome-icon :icon="['fas', 'circle']" style="cursor: pointer"/>
                      </span>

                      <span v-else-if="item.status == 0 || item.status == 100"
                            class="circle-white">
                        <font-awesome-icon :icon="['fas', 'circle']" style="cursor: pointer"/>
                      </span>

                      <span v-else-if="item.status == 1 || item.status == 100"
                            class="circle-green">
                        <font-awesome-icon :icon="['fas', 'circle']" style="cursor: pointer"/>
                      </span>

                      <span
                        v-else-if="item.status == 110
                           || item.status == 120
                           || item.status == 210
                           || item.status == 220"
                        class="circle-yellow">
                        <font-awesome-icon :icon="['fas', 'circle']" style="cursor: pointer"/>
                      </span>

                      <span v-else class="circle-gray">
                        <font-awesome-icon :icon="['fas', 'circle']" style="cursor: pointer"/>
                      </span>

                      <b-button variant="btn-menu"
                                style="color: #fff; text-align: left;">
                        <span style="font-weight: bold">{{ item.name }}</span>
                        <br>
                        <span style="font-size: 12px; font-style: italic;">
                          อัพเดท: {{ formatTime(item.updated_at) }}
                        </span>

                        <div class="when-closed" style="position: absolute;top: 10px;right: 20px;">
                          <font-awesome-icon :icon="['fas', 'arrow-circle-left']"/>
                        </div>

                        <div class="when-opened" style="position: absolute;top: 10px;right: 20px;">
                          <font-awesome-icon :icon="['fas', 'arrow-circle-down']"/>
                        </div>
                      </b-button>
                    </v-col>
                  </v-row>

                  <v-row class="px-5" v-b-toggle="'real' + item.code">
                    <template v-for="(values,key) in onlyValue(item.value)" v-if="item.value">
                      <template v-if="key !== 'datetime' && key !== 'population'">
                        <v-col class="set-style-border text-white">
                          <div style="font-weight: bold">
                            {{ values.name }}
                            <span style="font-weight: lighter; color: gray;">{{ values.unit }}</span>
                          </div>
                          <div v-if="values.value !== null" class="d-flex mt-2 align-items-end justify-content-center">
                            <h5 class="my-0">{{ toFormat(values.value) }}</h5>
                          </div>

                          <span v-if="values.diff < 0" style="color: #27AE60">
                            <font-awesome-icon :icon="['fas', 'sort-down']"/>
                            {{ (values.diff * -100).toFixed(1) }}
                            <span>%</span>
                          </span>
                          <span v-if="values.diff > 0" style="color: #FF3B30">
                            <font-awesome-icon :icon="['fas', 'sort-up']"/>
                            {{ (values.diff * 100).toFixed(1) }}
                            <span>%</span>
                          </span>
                        </v-col>
                      </template>

                    </template>
                  </v-row>

                  <b-collapse v-bind:id="'real' + item.code" class="mt-2">
                    <b-card>
                      <div style="padding: 3%">
                        <div class="set-card-collapse">
                          <div class="header-collapse">
                            <span style="font-weight: bold">{{ item.code }}</span>
                          </div>
                          <div style="padding: 2%">
                            <table width="100%">
                              <tr v-if="item.value && key !=='datetime'"
                                  v-for="(values, key) in item.value"
                                  @click="toGraph(item.id, key)">
                                <td>
                                  <span style="font-weight: bold">{{ values.name }}</span>
                                  <span style="color: #C4C4C4"> ({{ values.unit }})</span>
                                </td>
                                <td align="right">
                                  <span>{{ toFormat(values.value) }}</span> &nbsp;
                                  <span v-if="values.diff < 0" style="color: #27AE60">
                                    <font-awesome-icon :icon="['fas', 'sort-down']"/>
                                    {{ (values.diff * -100).toFixed(1) }}
                                    <span>%</span>
                                  </span>
                                  <span v-if="values.diff > 0" style="color: #FF3B30">
                                    <font-awesome-icon :icon="['fas', 'sort-up']"/>
                                    {{ (values.diff * 100).toFixed(1) }}
                                    <span>%</span>
                                  </span>

                                  <font-awesome-icon
                                    v-if="key !== 'datetime' && key !== 'population'"
                                    class="ml-2 text-success"
                                    :icon="['fas', 'chart-bar']"
                                  />
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <span style="font-weight: bold">วันที่อัพเดต</span>
                                  <span></span>
                                </td>
                                <td align="right">
                                  <span>{{ formatTime(item.updated_at) }}</span>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </b-card>
                  </b-collapse>
                </td>
              </tr>
            </tbody>
          </table>
        </b-tab>


        <b-tab :title="'MNF Grid (' +mnf_data.length+ ')'">
          <table class="table table-striped table-borderless text-white">
            <tbody>
              <tr v-for="item in mnf_data">
                <td>
                  <div>
                    <v-row>
                      <v-col>
                        <span class="circle-red">
                          <font-awesome-icon :icon="['fas', 'circle']" style="cursor: pointer"/>
                        </span>
                        <b-button v-b-toggle="item.code" variant="btn-menu" style="color: #fff">
                          <span style="font-weight: bold">{{ item.code }}</span>
                        </b-button>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col style="text-align: center">
                        <span style="font-weight: bold">ปริมาณใช้น้ำ</span>
                        <br>
                        <span style="color: #C4C4C4">(ลบ.ม./วัน)</span>
                        <br>
                        <span>{{item.usage_now && item.usage_now.value ? toFormat(item.usage_now.value) : '0'}}</span>
                      </v-col>

                      <v-col class="border-left-style" style="text-align: center">
                        <span style="font-weight: bold">Minimum Night Flow</span>
                        <br>
                        <span style="color: #C4C4C4">(ลบ.ม./ชม.)</span>
                        <br>
                        <span style="font-weight: bold">{{item.flow_now && item.flow_now.value ?
                          toFormat(item.flow_now.value) : '0'}}
                        </span>
                      </v-col>

                    </v-row>

                    <b-collapse v-bind:id="item.code" class="mt-2">
                      <b-card>
                        <div style="padding: 3%">
                          <div class="set-card-collapse">
                            <div class="header-collapse">
                              <span style="font-weight: bold">{{ item.code }}</span>
                            </div>
                            <div style="padding: 2%">
                              <table width="100%">
                                <tr>
                                  <td style="font-weight: bold">
                                    <span>ปริมาณใช้น้ำ(ลบ.ม/วัน)</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span style="margin-left: 15%;">7 วันย้อนหลัง</span>
                                  </td>
                                  <td align="right">
                                    <span>{{ item.usage_diff7d && item.usage_diff7d.value ? (item.usage_diff7d.value) :
                                      '0'}}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span style="margin-left: 15%;">ปัจจุบัน</span>
                                  </td>
                                  <td align="right">
                                    <span>{{ item.usage_now && item.usage_now.value ? (item.usage_now.value) : '0'}}
                                    </span>
                                  </td>
                                </tr>

                                <br/>
                                <tr>
                                  <td>
                                    <div style="border-bottom: 1px solid #FFFFFF;"></div>
                                  </td>
                                  <td align="right">
                                    <div style="border-bottom: 1px solid #FFFFFF;"></div>
                                  </td>
                                </tr>
                                <br/>

                                <tr>
                                  <td style="font-weight: bold">
                                    <span>Minimum Night Flow (ลบ.ม./ชม.)</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span style="margin-left: 15%;">เป้าหมาย (ลบ.ม./ชม.)</span>
                                  </td>
                                  <td align="right">
                                    <span>{{ item.flow_target && item.flow_target.value ? (item.flow_target.value) :
                                      '0'}}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span style="margin-left: 15%;">7 วันย้อนหลัง</span>
                                  </td>
                                  <td align="right">
                                    <span>{{ item.flow_diff7d && item.flow_diff7d.value ? (item.flow_diff7d.value) :
                                      '0'}}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span style="margin-left: 15%;">ปัจจุบัน</span>
                                  </td>
                                  <td align="right">
                                    <span>{{ item.flow_now && item.flow_now.value ? (item.flow_now.value) : '0'}}</span>
                                  </td>
                                </tr>

                                <br/>
                                <tr>
                                  <td>
                                    <div style="border-bottom: 1px solid #FFFFFF;"></div>
                                  </td>
                                  <td>
                                    <div style="border-bottom: 1px solid #FFFFFF;"></div>
                                  </td>
                                </tr>
                                <br/>

                                <tr>
                                  <td style="font-weight: bold">
                                    <span>Minimum P (Bar)</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span style="margin-left: 15%;">ปัจจุบัน</span>
                                  </td>
                                  <td align="right">
                                    <span>
                                      {{ item.p_now && item.p_now.value ? (item.p_now.value) : '0'}}
                                      <sup>{{ item.p_now && item.p_now.movement ? '(' + item.p_now.movement + ')' :
                                        ''}}</sup>

                                    </span>
                                  </td>
                                </tr>

                                <br/>
                                <tr>
                                  <td>
                                    <div style="border-bottom: 1px solid #FFFFFF;"></div>
                                  </td>
                                  <td>
                                    <div style="border-bottom: 1px solid #FFFFFF;"></div>
                                  </td>
                                </tr>
                                <br/>

                                <tr>
                                  <td style="font-weight: bold">
                                    <span>ความสมบูรณ์ข้อมูล</span>
                                  </td>
                                  <td align="right" style="font-weight: bold">
                                    <span>{{ item.integrity && item.integrity.period ? '[' + item.integrity.period + ']'
                                      :
                                      '-'}}
                                    </span>
                                    &nbsp;
                                    <span>{{ item.integrity && item.integrity.percent ? (item.integrity.percent
                                      *100).toFixed(2) + '%' : ''}}
                                    </span>
                                  </td>
                                </tr>
                                <br/>

                              </table>
                            </div>
                          </div>
                        </div>
                      </b-card>
                    </b-collapse>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </b-tab>
      </b-tabs>
      <div style="text-align: center">
        <span style="color: #C4C4C4">version 1.4</span>
      </div>

    </div>


  </div>
</template>


<script>
  import Vue from 'vue'
  import Api from '../providers/Api'
  import moment from 'moment'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { library } from '@fortawesome/fontawesome-svg-core'
  import { fas } from '@fortawesome/free-solid-svg-icons'

  import {
    BTabs,
    BCollapse,
    ButtonPlugin,
    CardPlugin,
    BNavbar,
    NavbarPlugin,
    BNav,
    NavPlugin,
    BButton
  } from 'bootstrap-vue'
  import { TabsPlugin } from 'bootstrap-vue'
  import { CollapsePlugin } from 'bootstrap-vue'
  import BootstrapVue from "bootstrap-vue";
  import "bootstrap/dist/css/bootstrap.css";
  import "bootstrap-vue/dist/bootstrap-vue.css";

  Vue.component('b-tabs', BTabs)
  Vue.component('b-collapse', BCollapse)
  Vue.component('b-navbar', BNavbar)
  Vue.component('b-nav', BNav)
  Vue.component('b-button', BButton)

  Vue.use(NavbarPlugin)
  Vue.use(NavPlugin)
  Vue.use(BootstrapVue);

  Vue.use(TabsPlugin)
  Vue.use(CollapsePlugin)
  Vue.use(ButtonPlugin)
  Vue.use(CardPlugin)
  Vue.component('font-awesome-icon', FontAwesomeIcon)

  library.add(fas)

  export default {

    components: {},

    props: {},

    created () {
      this.getBranch()

      let interval = setInterval(() => {
        if (this.$store.state.$user.id !== null) {
          let departmentStore = localStorage.getItem('department')
          if(departmentStore){
            departmentStore = JSON.parse(departmentStore)
            this.sector_id = departmentStore.sector_id
            this.district_id = departmentStore.district_id
            this.branch_id =  departmentStore.branch_id
          }else{
            this.sector_id = this.$store.state.$user.sector_id
            this.district_id = this.$store.state.$user.district_id
            this.branch_id = this.$store.state.$user.branch_id
            let department = {
              sector_id: this.sector_id,
              district_id: this.district_id,
              branch_id: this.branch_id
            }

            try {
              localStorage.setItem('department', JSON.stringify(department))
            } catch (e) {
              console.error(`Cannot add department to localStorage`)
            }
          }
          this.$store.state.sector_id = this.sector_id
          this.$store.state.district_id = this.district_id
          this.$store.state.branch_id = this.branch_id

          this.getDataMNF()
          this.getDataRealTime()
          clearInterval(interval)
        }
      }, 1000)
    },

    data () {
      return {
        showCollapse: true,
        realtime_data: [],
        mnf_data: [],
        branchs: [],
        branch_name: 'เลือกสาขา',
        districts: [],
        id: 'UsageProblem',
        sector_id: null,
        district_id: null,
        branch_id: null,
        picker: new Date().toISOString().substr(0, 10),
      }
    },
    methods: {
      flatArray(data, key_to_recusive, return_array = null, deep = 0){
        if (return_array === null)
          return_array = []
        data.forEach((value, key) => {
          let tmp = JSON.parse(JSON.stringify(value))
          if (value.hasOwnProperty(key_to_recusive)) {
            delete tmp[key_to_recusive]
          }
          tmp.deep = deep
          return_array.push(tmp)
          if (value.hasOwnProperty(key_to_recusive)) {
            this.flatArray(value[key_to_recusive], key_to_recusive, return_array, deep + 1)
          }
        })
        return return_array
      },
      onlyValue (value) {
        if (value.p1in || value.flow || value.pressure) {
          return {
            p1in: value.p1in || { name: 'P in', unit: 'Bar', value: null },
            flow: value.flow || { name: 'Flow', unit: 'M3/Hr', value: null },
            pressure: value.pressure || { name: 'P out', unit: 'Bar', value: null },
          }
        }

        return {}
      },

      getDataMNF () {
        if (!this.branch_id) {
          return
        }
        this.post('/api/dashboard/MNF_grid/get_summarize', {
          "page": 1,
          "branch": this.branch_id,
          // "date": this.picker,
          "date": moment().format('YYYY-MM-DD'),
          "unit": null
        }).then(res => {
          this.mnf_data = this.flatArray(res.data.data,'linked_loggers')
        })
      },
      getDataRealTime () {
        if (!this.branch_id) {
          return
        }
        this.get(`/api/dashboard/realtime_grid?page=1&branch=${ this.branch_id }`).then(res => {
          this.realtime_data = this.flatArray(res.data.data,'linked_loggers')

        })
      },
      onClickBranch (e) {
        // this.$emit('update:branch', {
        //   branchId: parseInt(this.branch_id),
        //   districtId: parseInt(this.district_id)
        // })

        const district = _.first(_.filter(this.districts, { value: this.district_id }))
        this.sector_id = district.sector_id

        this.branch_id = e.target.value
        let department = {
          sector_id: this.sector_id,
          district_id: this.district_id,
          branch_id: this.branch_id
        }

        try {
          localStorage.setItem('department', JSON.stringify(department))
        } catch (e) {
          console.error(`Cannot add department to localStorage`)
        }

        this.$store.state.sector_id = this.sector_id
        this.$store.state.district_id = this.district_id
        this.$store.state.branch_id = this.branch_id
        this.getDataMNF()
        this.getDataRealTime()
      },
      toGraph (logger_id, parameter) {
        if (parameter !== 'datetime' && parameter !== 'population')
          this.$router.push({ path: '/graph', query: { logger_id: logger_id, parameter: parameter } })
      },
      getBranch () {
        this.get('/api/districts/lov', {}, true, true).then(({ data }) => {
          this.districts = data.data
        })
        this.get('/api/branches/lov', {}, true, true).then(({ data }) => {
          this.branchs = data.data
        })
      },

      StrToBool (field) {
        return field.toLowerCase().trim() === 'true'
      },
      formatTime (date) {
        if (date) {
          return moment(date).add(543, 'y').format('DD-MM-YYYY HH:mm:ss')
        }
      },
      toFormat (value) {
        if (parseFloat(value)) {
          if (parseFloat(value).toString().length === value.toString().length) {
            return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(parseFloat(value))
          }
        }

        return value
      },
    },

    mixins: [
      Api,
    ],
  }

</script>

<style lang="scss">
  .set-style-card {
    background-color: #1B1B1B;
    border-radius: 8px;
    padding: 1%;
  }

  .app-body {
    background-color: #262628;
  }

  .border-left-style {
    border-left: 1px solid rgba(255, 255, 255, 0.3);
  }

  .set-icon-menu {
    font-size: 30px;
    padding: 3%;
  }

  .set-card-collapse {
    border: 1px solid #666666;
    border-radius: 2px;
  }

  .header-collapse {
    background-color: #262628;
    padding: 2%;
  }

  .circle-red {
    font-size: 10px;
    color: #FF3B30;
    padding: 3%;
  }

  .circle-green {
    font-size: 10px;
    color: #27AE60;
    padding: 3%;
  }

  .circle-yellow {
    font-size: 10px;
    color: #FFCC00;
    padding: 3%;
  }

  .circle-gray {
    font-size: 10px;
    color: gray;
    padding: 3%;
  }

  .circle-white {
    font-size: 10px;
    color: #ffffff;
    padding: 3%;
  }

  .collapse > .when-opened, :not(.collapsed) > .when-closed {
    display: none;
  }

  .card {
    background-color: #1B1B1B;
  }

  .nav-tabs {
    border: 1px;

  }

  .nav-tabs .nav-link {
    background-color: #293345;
    color: #fff;
    border: 1px solid #313D4F;
    border-top-left-radius: 0rem;
    border-top-right-radius: 0rem;
  }

  .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #fff;
    background-color: rgba(46, 161, 248, 0.4);;
    border-color: #2EA1F8;
  }

  .btn-menu {
    color: #fff
  }

  .dropdown_branch {
    color: #fff;
    background-color: #1B1B1B;
    border: 1px solid #fff;
    box-sizing: border-box;
    border-radius: 5px;
    height: 35px;
    width: 150px;
  }

  .card-body {
    padding: 0%;
  }

  .set-padding li {
    width: 50%
  }

  .set-padding-select b-navbar-nav {
    padding-left: 0px;
  }

  .set-mt-3 {
    margin-left: -24px !important;
  }

  .set-style-border {
    text-align: center;
    border-right: 1px solid;
  }

  .set-style-border:last-child {
    text-align: center;
    border-right: none;
  }

  .set-padding-select {
    padding-left: 0px !important;
  }

  table {
    & .col {
      padding: 5px;
    }

    &.table-striped tbody tr:nth-of-type(2n) {
      background-color: rgba(255, 255, 255, 0.05);
    }
  }

  :not(.collapsed) .when-closed {
    display: none;
  }

  .collapsed {
    & .when-opened {
      display: none;
    }

    & .when-closed {
      display: block;
    }
  }
</style>
